<div class="di-donnees-patient-cv">
	<small class="title">Données de la carte</small>
	<div class="patient-container">
		<lua-icone
			[isIcon]="true"
			customIconName="lecturecv"
			color="CouleurPrimaire"
  		></lua-icone>
		<div class="patient-infos-container" *ngIf="patient">
			<p class="patient-name">{{formattedLastName}} {{formattedFirstName | firstUpperCase}}</p>
			<small class="patient-info">Né le {{formattedBirthDate}}</small>
			<small class="patient-info">N° de Sécurité Social : {{formattedSSN}}</small>
		</div>
	</div>
</div>